import AdminFxs from 'models/api/admin';
import AdvisorFxs from 'models/api/advisor';
import AnswersFxs from 'models/api/answers';
import ControlsDataFxs from 'models/api/controls-data';
import DocumentsFxs from 'models/api/documents';
import EmployerFxs from 'models/api/employer';
import GuideFxs from 'models/api/guide';
import MiscFxs from 'models/api/misc';
import OriginatorFxs from 'models/api/originator';
import ParticipantsFxs from 'models/api/participants';
import QInstancesFxs from 'models/api/q-instances';
import QuestionnairesFxs from 'models/api/questionnaires';
import StripeFxs from 'models/api/stripe';
import TermsAndConditionsFxs from 'models/api/terms-and-conditions';
import UsersFxs from 'models/api/users';

const $$api = {
    admin: AdminFxs,
    advisor: AdvisorFxs,
    answers: AnswersFxs,
    controlsData: ControlsDataFxs,
    documents: DocumentsFxs,
    employer: EmployerFxs,
    guide: GuideFxs,
    misc: MiscFxs,
    originator: OriginatorFxs,
    participants: ParticipantsFxs,
    qInstances: QInstancesFxs,
    questionnaires: QuestionnairesFxs,
    stripe: StripeFxs,
    termsAndConditions: TermsAndConditionsFxs,
    users: UsersFxs,
};

export default $$api;
